import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import routesConfig from "../../config/routes";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../../AuthPages/Login";
import { useAuth } from "../../hooks/useAuth";
import DefaultLayout from "../DefaultLayout/DefaultLayout";
import PageNotFound from "../PageNotFound/PageNotFound";
import Loading from "../LoadinScreen/Loading";
import ForgotPassword from "../../AuthPages/ForgotPassword";

const DynamicRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, allowedRoutes } = useAuth();

  useEffect(() => {
    // If the user is authenticated and is on the login page, redirect them to dashboard.
    if (isAuthenticated && allowedRoutes?.length > 0 && (location.pathname === "/login" || location.pathname === "/")) {
      navigate("/dashboard", { replace: true });
    } else if (!isAuthenticated && location.pathname !== "/forgot-password") {
      // removeToken();
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated]);

  

  return (
    <Suspense fallback={<div className="flex justify-center items-center h-full text-center"><Loading /></div>}>
      <Routes>
        {/* Public Route: Login */}
        <Route path="*" element={<PageNotFound />} />
        <Route path="/" element={<DefaultLayout />} />
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {!isAuthenticated ? (
          <Route path="/login" element={<Login />} />
        ) : (
          <Route path="/login" element={<Navigate to="/dashboard" replace />} />
        )}

        {/* Protected Routes: Only available if authenticated */}
        {routesConfig.map((route, index) => {
          const routeKey = route.key || `route-${index}`;
          const Element = route.component;
          return (
            <Route
              key={routeKey}
              path={route.path}
              element={
                <ProtectedRoute permissionKey={route.key}>
                  <DefaultLayout page={<Element />} />
                </ProtectedRoute>
              }
            />
          );
        })}

      </Routes>
    </Suspense>
  );
};

export default DynamicRoutes;
